import { BoardInvitation } from '../contract';

// How answering to a board's pending invitations turns the list into its next version: a new list, the original untouched,
// with no React or network in it, so it can be tested directly. data/invitations.ts applies it to the cache.

// A cancelled invitation leaves the list. A list that isn't loaded, or an id that isn't in it, comes back unchanged.
export const withoutBoardInvitation = (invitations: BoardInvitation[] | undefined, invitationId: string) =>
    invitations?.filter((invitation) => invitation.id !== invitationId);
